import classNames from 'classnames';

import Styles from './VoucherSplash.module.scss';

const a11yUnits: Record<string, string> = {
    p: ' poäng',
    kr: ' kronor',
};

type VoucherSplashProps = {
    value: number | string;
    unit?: string;
    size?: 'small' | 'medium' | 'large';
    extraBonus?: boolean;
    ariaHidden?: boolean;
};

const VoucherSplash = ({
    value,
    unit = '',
    size = 'medium',
    extraBonus = false,
    ariaHidden = false,
}: VoucherSplashProps) => {
    const displayValue = `${value}${unit}`;

    return (
        <div
            className={classNames(Styles.VoucherValueWrapper, Styles[size], {
                [Styles.ExtraBonusVoucher]: extraBonus,
            })}
            aria-hidden={ariaHidden}
        >
            <div
                className={classNames(Styles.VoucherValue, {
                    [Styles.fontSmall]: displayValue.length >= 6,
                })}
            >
                <span>
                    {extraBonus && typeof value === 'number' ? '+' : ''}
                    {value}
                    <span aria-hidden>{unit}</span>
                    <span className="u-hiddenVisually">{a11yUnits[unit]}</span>
                </span>
            </div>
        </div>
    );
};

export default VoucherSplash;
